/**
 * next-devtools-stub.js
 *
 * Production no-op stub for next/dist/compiled/next-devtools.
 *
 * WHY THIS EXISTS:
 * Next.js 15.3+ has a bundling regression where `next/dist/compiled/next-devtools`
 * (763KB — the entire DevTools/Segment Explorer bundle) is included in production
 * builds via client/page-bootstrap.js, which imports `dispatcher` from this module
 * unconditionally (not guarded by NODE_ENV !== 'production').
 *
 * The chunk (c3c6f969-*) ships to browsers as part of the main JS bundle, causing:
 *   - TBT: ~1.5s on mobile (PSI score ~50-62 across all pages)
 *   - ~763KB of dev tooling served to real visitors
 *
 * FIX: webpack alias in next.config.ts replaces the real module with this stub
 * in production builds only. The stub exports no-op functions for all dispatcher
 * methods, preventing any runtime errors while ensuring the 763KB chunk never
 * reaches production visitors.
 *
 * All methods are no-op functions returning undefined (safe: callers use
 * fire-and-forget pattern — no return value consumed in production code paths).
 *
 * Verified against Next.js 15.5.15 dispatcher API. If Next.js is upgraded and
 * adds new dispatcher methods, this stub will silently ignore them (safe —
 * missing keys return undefined, not throw, in JS).
 *
 * Tracking: Next.js 15.3+ bundling regression — no fix available in 15.5.x stable
 * as of 2026-05-25. Remove this stub when upstream ships a proper production guard.
 */

'use strict';

const noop = () => {};

const dispatcher = {
  onBuildOk: noop,
  onBuildError: noop,
  onBeforeRefresh: noop,
  onRefresh: noop,
  onVersionInfo: noop,
  onStaticIndicator: noop,
  onDebugInfo: noop,
  onDevIndicator: noop,
  onDevToolsConfig: noop,
  onUnhandledError: noop,
  onUnhandledRejection: noop,
  openErrorOverlay: noop,
  closeErrorOverlay: noop,
  toggleErrorOverlay: noop,
  buildingIndicatorHide: noop,
  buildingIndicatorShow: noop,
  renderingIndicatorHide: noop,
  renderingIndicatorShow: noop,
  segmentExplorerNodeAdd: noop,
  segmentExplorerNodeRemove: noop,
  segmentExplorerUpdateRouteState: noop,
};

module.exports = {
  dispatcher,
  DevOverlayContext: null,
  renderAppDevOverlay: noop,
  renderPagesDevOverlay: noop,
  useDevOverlayContext: noop,
};
